export class StudentMeetupAdditionalInfoModel {
	notes: string;
	purpose: string;
	context: string;
}

export function StudentMeetupAdditionalInfoModel_ClassTransform_Type() {
	return StudentMeetupAdditionalInfoModel;
}
